import { theme } from 'antd'
import { observer } from 'mobx-react-lite'

import { classNames } from '@/Ship/Helpers/classNames'
import { dashboardManager } from '@/Ship/Stores/DashboardManager'

import { Panel, formatInt, useChartColors } from './shared'
import styles from './Overview.module.css'

const PROBLEM = 'application-problem'

/**
 * «Заявки в роботі» — скільки заявок зараз на кожному кроці, у порядку руху
 * (нова → … → документообіг) і окремо проблемні. Одна міра на всіх рядках —
 * один колір; проблемні — кольором помилки з назвою статусу поруч, не самим
 * кольором. Назви статусів — з довідника тенанта.
 */
export const PipelineCard = observer(() => {
    const { token } = theme.useToken()
    const chart = useChartColors()
    const { overview, isOverviewLoading } = dashboardManager
    const stages = overview?.pipeline ?? []
    const total = stages.reduce((sum, stage) => sum + stage.count, 0)
    const max = Math.max(1, ...stages.map((stage) => stage.count))

    return (
        <Panel
            block="overview-pipeline"
            title="Заявки в роботі"
            subtitle="Зараз, за статусами"
            extra={overview ? `усього ${formatInt(total)}` : null}
            loading={isOverviewLoading && !overview}
            empty={overview && total === 0 ? 'Зараз немає заявок у роботі' : false}
            skeletonRows={8}
        >
            <div className={classNames(styles['bars'])}>
                {stages.map((stage) => (
                    <div key={stage.code} className={classNames(styles['barRow'])} data-stage={stage.code}>
                        <span className={classNames(styles['barLabel'])} title={stage.title}>
                            {stage.title}
                        </span>
                        <span className={classNames(styles['barValue'])}>
                            {formatInt(stage.count)}
                            <span className={classNames(styles['barMuted'])}>
                                {total > 0 ? `${Math.round((stage.count / total) * 100)} %` : ''}
                            </span>
                        </span>
                        <div className={classNames(styles['track'])}>
                            <div
                                className={classNames(styles['fill'])}
                                style={{
                                    width: stage.count > 0 ? `${(stage.count / max) * 100}%` : 0,
                                    background: stage.code === PROBLEM ? token.colorError : chart.primary,
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </Panel>
    )
})
